/* eslint-disable no-restricted-globals */
/* eslint-disable no-useless-concat */
import nBossConnection from 'modules/base/service/nBossConnection';

class FrontendExceptionReporterService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'frontendExceptionReporterControl';
	}

	/**
	 * @param {string} subject
	 * @param {string|null} html
	 * @param {string|object} text
	 * @return {Promise<boolean>}
	 */
	report(subject, html, text) {
		const extraInfo = {
			'User Agent': navigator.userAgent,
			'Platform': navigator.platform,
			'Language': navigator.language,
			'Languages': navigator.languages.join(', '),
			'Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
			'URL': window.location.href,
			'Referrer': document.referrer,
			'Device Memory (GB)': navigator.deviceMemory,
			'CPU Cores': navigator.hardwareConcurrency,
			'Screen Size': screen.width + 'x' + screen.height,
			'Pixel Ratio': window.devicePixelRatio,
			'Viewport': window.innerWidth + 'x' + window.innerHeight,
			'Timestamp': new Date().toISOString(),
		};

		let baseText = '';
		if (typeof text === 'string') {
			baseText = text;
		} else {
			try {
				baseText = JSON.stringify(text, null, 2);
			} catch (e) {
				baseText = '[Error: Unable to stringify error details]';
			}
		}

		let textPayload = 'Error details:\n' + baseText + '\n\n' + 'Environment info:\n';

		for (let key in extraInfo) if (Object.prototype.hasOwnProperty.call(extraInfo, key)) textPayload += key + ': ' + extraInfo[key] + '\n';

		return this.connection
			.post('/' + this.CONTROL + '/report', { subject, html, text: textPayload })
			.then(response => response.data)
			.catch(err => { console.warn('[FrontendExceptionReporterService] Failed to send report:', err); return false; });
	}
}

export default new FrontendExceptionReporterService();